import React, { useState } from 'react';
import AdminDashboard from './AdminDashboard';
// UserManagement removed - users are managed at rideya.bz
import VehicleManagement from './VehicleManagement';
import AdvertisementManagement from './AdvertisementManagement';
import EmailLogs from './EmailLogs';
import SocialLoginConfig from './SocialLoginConfig';
import VanRouteManagement from './VanRouteManagement';
import DriverManagement from './DriverManagement';
import GlobalSettings from './GlobalSettings';
// Removed for garbageTracker: RequestManagement, VehicleShareManagement, TownManagement,
// RoutePointsView, RouteDefinitionManagement, GeofencePresetManagement, ConductorManagement,
// RouteSubscriptionManagement, LocationUpdateManagement, UserManagement

/**
 * Comprehensive Admin Panel
 * Central hub for all administrative functions with tabbed interface
 */
const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [showGlobalSettings, setShowGlobalSettings] = useState(false);

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    // Users tab removed - users are managed at rideya.bz
    { id: 'vehicles', label: 'Garbage Trucks', icon: '🚛' },
    { id: 'van-routes', label: 'Garbage Truck Routes', icon: '🛣️' },
    { id: 'drivers', label: 'Drivers', icon: '👷' },
    { id: 'advertisements', label: 'Advertisements', icon: '📢' },
    { id: 'social-login', label: 'Social Login', icon: '🔐' },
    { id: 'email-logs', label: 'Email Logs', icon: '📧' }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <AdminDashboard onNavigate={setActiveTab} />;
      // Users case removed - users are managed at rideya.bz
      case 'vehicles':
        return <VehicleManagement />;
      case 'van-routes':
        return <VanRouteManagement />;
      case 'drivers':
        return <DriverManagement />;
      case 'advertisements':
        return <AdvertisementManagement />;
      case 'social-login':
        return <SocialLoginConfig />;
      case 'email-logs':
        return <EmailLogs />;
      default:
        return <AdminDashboard onNavigate={setActiveTab} />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-gray-900">Admin Panel</h1>
              <span className="ml-2 text-sm text-gray-500">Garbage Truck Tracking System</span>
            </div>
            <div className="flex items-center space-x-4">
              <button
                onClick={() => setShowGlobalSettings(true)}
                className="flex items-center px-3 py-1 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors"
                title="Global Settings"
              >
                <span className="mr-1">⚙️</span>
                Settings
              </button>
              <div className="text-sm text-gray-600">
                Comprehensive Data Management
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-1 overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center px-4 py-3 text-sm font-medium border-b-2 whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <span className="mr-2">{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {renderContent()}
      </div>

      {/* Global Settings Modal */}
      <GlobalSettings
        isOpen={showGlobalSettings}
        onClose={() => setShowGlobalSettings(false)}
      />
    </div>
  );
};

export default AdminPanel;